module.exports = __webpack_public_path__ + "static/VideoJuliánpeñasub-a8f7c4b7a2dcea88734aa5581068e7d8.mp4";